export { default as VictoryErrorBar } from "./victory-errorbar";
export { default as ErrorBar } from "./error-bar";


//////////////////
// WEBPACK FOOTER
// ./~/victory-errorbar/es/index.js
// module id = ./node_modules/victory-errorbar/es/index.js
// module chunks = 1